/**
 * This used to be used for kiss metrics and heap metrics which are no longer
 * used. There are many references to this function so we haven't removed it
 * yet.
 */
export function track() {
    console.debug('public/js/common/analytics#track is deprecated and a no-op.');
}



// WEBPACK FOOTER //
// ./common/analytics.js